<app-empty-state title="Service voruebergehend nicht verfuegbar"
                 subtitle="Bitte versuchen Sie es spaeter erneut."
                 [showButton]="true"
                 buttonText="Erneut versuchen"
                 (buttonClick)="reloadApp()">
</app-empty-state>
